import React from 'react';

export default function ConversationTime({ timeStamp }) {
	const dateNowEST = new Date(
		new Date().toLocaleString('en-US', {
			timeZone: 'America/New_York',
		}),
	);

	const diff_hours = (dt2, dt1) => {
		var diff = (dt2.getTime() - dt1.getTime()) / 1000;
		diff /= 60 * 60;
		return Math.abs(Math.round(diff));
	};

	const convertToLocalTime = () => {
		const hourDifference = diff_hours(dateNowEST, new Date());
		const activityTime = new Date(timeStamp);
		const localTime = activityTime.setHours(
			activityTime.getHours() - hourDifference,
		);
		return new Date(localTime);
	};

	function formatDate(localizedTimeStamp) {
		var dt = (dt = localizedTimeStamp),
			today = new Date(Date.now()),
			yesterday = new Date(today),
			diffYears = new Date().getFullYear() - dt.getFullYear();

		yesterday.setDate(yesterday.getDate() - 1);

		const ltsDayStamp =
			localizedTimeStamp.getDate() +
			'-' +
			localizedTimeStamp.getMonth() +
			'-' +
			localizedTimeStamp.getFullYear;

		var dateString = '';
		if (
			today.getDate() +
				'-' +
				today.getMonth() +
				'-' +
				today.getFullYear ==
			ltsDayStamp
		) {
			dateString = 'Today';
		} else if (
			yesterday.getDate() +
				'-' +
				yesterday.getMonth() +
				'-' +
				yesterday.getFullYear ==
			ltsDayStamp
		) {
			dateString = 'Yesterday';
		} else if (diffYears < 1) {
			dateString = getDateAndMonth(localizedTimeStamp);
		} else if (diffYears >= 1) {
			dateString = localizedTimeStamp.toLocaleDateString('en-US');
		}
		return (
			dateString +
			' ' +
			localizedTimeStamp.toLocaleTimeString('en-US', {
				hour: 'numeric',
				minute: '2-digit',
			})
		);
	}

	const getDateAndMonth = localizedTimeStamp => {
		return (
			localizedTimeStamp.getMonth() +
			1 +
			'/' +
			localizedTimeStamp.getDate()
		);
	};

	return <span>{formatDate(convertToLocalTime())}</span>;
}
